import React from "react";

const InvoiceTable = () => {

  // ✅ DATA INSIDE SAME FILE
  const invoiceTableData = [
    {
      id: "Inv-001",
      name: "Antony Lewis",
      role: "Web Designer",
      company: "Brightware Innovations",
      createdDate: "14 Jan 2024",
      dueDate: "14 Jan 2024",
      amount: "$3000",
      status: "Partially Paid",
      img: "https://i.pravatar.cc/40?img=1"
    },
    {
      id: "Inv-002",
      name: "Antony Lewis",
      role: "Web Designer",
      company: "Brightware Innovations",
      createdDate: "14 Jan 2024",
      dueDate: "14 Jan 2024",
      amount: "$3000",
      status: "Partially Paid",
      img: "https://i.pravatar.cc/40?img=2"
    },
    {
      id: "Inv-003",
      name: "Antony Lewis",
      role: "Web Designer",
      company: "Brightware Innovations",
      createdDate: "14 Jan 2024",
      dueDate: "14 Jan 2024",
      amount: "$3000",
      status: "Sent",
      img: "https://i.pravatar.cc/40?img=3"
    },
    {
      id: "Inv-004",
      name: "Antony Lewis",
      role: "Web Designer",
      company: "Brightware Innovations",
      createdDate: "14 Jan 2024",
      dueDate: "14 Jan 2024",
      amount: "$3000",
      status: "Paid",
      img: "https://i.pravatar.cc/40?img=4"
    },
  ];

  // ✅ STATUS COLOR FUNCTION
  const getStatusBadge = (status) => {
    switch (status) {
      case "Paid":
        return "success";
      case "Partially Paid":
        return "primary";
      case "Sent":
        return "danger";
      default:
        return "secondary";
    }
  };

  return (
    <div className="card shadow-sm border-0 mt-3">
      <div className="card-body">

        <div className="table-responsive">
          <table className="table align-middle">

            {/* HEADER */}
            <thead className="text-muted">
              <tr>
                <th>Invoice ID</th>
                <th>Client Name</th>
                <th>Company Name</th>
                <th>Created Date</th>
                <th>Due Date</th>
                <th>Amount</th>
                <th>Status</th>
              </tr>
            </thead>

            {/* BODY */}
            <tbody>
              {invoiceTableData.map((item, index) => (
                <tr key={index} className="border-top">

                  {/* ID */}
                  <td className="fw-semibold">{item.id}</td>

                  {/* CLIENT */}
                  <td>
                    <div className="d-flex align-items-center">
                      <img
                        src={item.img}
                        alt=""
                        className="rounded-circle me-2"
                        width="40"
                        height="40"
                      />
                      <div>
                        <div className="fw-semibold">{item.name}</div>
                        <small className="text-muted">{item.role}</small>
                      </div>
                    </div>
                  </td>

                  {/* COMPANY */}
                  <td>{item.company}</td>

                  {/* DATES */}
                  <td>{item.createdDate}</td>
                  <td>{item.dueDate}</td>

                  {/* AMOUNT */}
                  <td className="fw-semibold">{item.amount}</td>

                  {/* STATUS */}
                  <td>
                    <span
                      className={`badge bg-${getStatusBadge(item.status)} px-3 py-2`}
                    >
                      {item.status}
                    </span>
                  </td>

                </tr>
              ))}
            </tbody>

          </table>
        </div>

      </div>
    </div>
  );
};

export default InvoiceTable;